
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/emails/emailTemplates",
      function () {
        return require("private-next-pages/emails/emailTemplates/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/emails/emailTemplates"])
      });
    }
  